import { categories, ctaButtons } from '@/mocks/categories';

export default function CategoryGrid() {
  const allItems = [
    ...categories.map((cat) => ({ ...cat, isCta: false })),
    ...ctaButtons.map((btn) => ({ name: btn.name, url: btn.url, icon: 'ri-shopping-bag-3-line', isCta: true })),
  ];

  return (
    <section className="py-20 md:py-28 px-4 md:px-8 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-4">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Shop by
            <br />
            Category
          </h2>
          <p className="font-body text-foreground-500 text-sm max-w-xs">
            Browse our complete collection of CSSBuy spreadsheet categories — every link hand-picked and verified daily.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {allItems.map((item, idx) => (
            <a
              key={item.name}
              href={item.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative rounded-2xl p-5 md:p-6 flex flex-col items-center justify-center text-center min-h-[140px] transition-all duration-300 cursor-pointer ${
                item.isCta
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : idx % 2 === 0
                    ? 'bg-foreground-900 text-white hover:bg-foreground-800'
                    : 'bg-background-50 text-foreground-900 hover:bg-background-200'
              }`}
            >
              <span className="w-10 h-10 flex items-center justify-center mb-3">
                <i className={`${item.icon} text-2xl ${item.isCta ? 'text-white' : idx % 2 === 0 ? 'text-primary-400' : 'text-primary-500'}`}></i>
              </span>
              <span className={`font-label font-semibold text-sm md:text-base whitespace-nowrap ${item.isCta ? 'text-white' : ''}`}>
                {item.name}
              </span>
              {!item.isCta && (
                <span className={`text-xs mt-1.5 ${idx % 2 === 0 ? 'text-white/50' : 'text-foreground-400'}`}>
                  View finds
                </span>
              )}
              {item.isCta && (
                <span className="text-xs mt-1.5 text-white/70">Go to store</span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}